import { TransactionStatus } from '~/types'

export const QUEUE_TRANSACTION_STATUSES = [
  TransactionStatus.Queued,
  TransactionStatus.Drafted,
  TransactionStatus.Created,
  TransactionStatus.Approved,
]

export const PENDING_TRANSACTION_STATUSES = [
  TransactionStatus.Queued,
  TransactionStatus.Drafted,
  TransactionStatus.Created,
  TransactionStatus.Approved,
  TransactionStatus.Submitted,
]

export const SUBMITTED_TRANSACTION_STATUSES = [
  TransactionStatus.Submitted,
  TransactionStatus.Succeeded,
  TransactionStatus.Failed,
]

export const CONFIRMED_TRANSACTION_STATUSES = [
  TransactionStatus.Succeeded,
  TransactionStatus.Failed,
]

// Random txn hash to send to a dapp using wallet connect for accounts with threshold > 1.
export const DEFAULT_TXN_HASH =
  '0x641ec77e4dfadfcfcc6d7bbb31302216bafbb0de08d2b785470f38f45d18e2b8'
